<script>
  import formFieldMixin from './form-field-mixin.js'

  export default {
    mixins: [
      formFieldMixin
    ],
    props: {
      rows: {
        type: Number,
        default: 5
      }
    }
  }
</script>
<template>
  <b-form-group
    :description="description"
    :label="label"
    :label-for="inputName"
    :invalid-feedback="violations"
    :labelClass="labelClasses"
  >
    <b-form-textarea
      :id="inputName"
      :value="value"
      :placeholder="placeholder"
      @input="updateField($event)"
      :state="!isInvalid"
      :readonly="isReadOnly"
      :rows="rows"
      trim
    ></b-form-textarea>
  </b-form-group>
</template>
